import React from 'react';
import StaticBadge, { StaticBadgeProps } from './StaticBadge';
import ReactiveBadge, { ReactiveBadgeProps } from './ReactiveBadge';

type TooltipDisplayFunction = (item: React.ReactNode, index: number, total: number) => React.ReactNode;

export type BaseOverflowBadgeProps = {
  list: any[];
  delineated?: boolean;
  tooltipDisplay?: TooltipDisplayFunction;
};

// Use ReactiveBadge only when it's the sole instance on a page.
// For multiple instances, use StaticBadge to avoid performance issues
// caused by ReactiveBadge's additional memory logic.

const ListOverflowBadge = (props: StaticBadgeProps | ReactiveBadgeProps) => {
  return (props as StaticBadgeProps).show ? <StaticBadge {...(props as StaticBadgeProps)} /> : <ReactiveBadge {...(props as ReactiveBadgeProps)} />;
};

export default ListOverflowBadge;

export const formatListForTooltip = (tooltipDisplay: TooltipDisplayFunction | undefined, list: any[]): any => {
  if (!tooltipDisplay) return 'No tooltip display function provided';
  return list.map((div, index) => tooltipDisplay(div, index, list.length));
};
